import { IActionResponse, IActionResult, BaseClient, IPagedResult } from "../";
import { ApiParams } from "../../../assets/utils/lib";
import { ClaimDto, GridClaimDto, SearchClaimDto } from "../../dto";
import { LookupDto } from "../../dto/account/lookupDto";

export class ClaimClient extends BaseClient {
  routes = ["account", "claim"];

  async getClaimAsync(id: string | undefined): Promise<ClaimDto> {
    const actions: string[] = ["GetClaim"];
    const params: ApiParams[] = [new ApiParams("Id", id, true)];

    const result: ClaimDto = await this.getAsync<ClaimDto>(actions, params);
    return result;
  }

  async getClaimsAsync(typeId?: string | undefined): Promise<ClaimDto[]> {
    const actions: string[] = ["GetClaims"];
    const params: ApiParams[] = [new ApiParams("typeId", typeId, true)];

    const result: ClaimDto[] = await this.getAsync<ClaimDto[]>(actions, params);
    return result;
  }

  async searchClaimsAsync(
    payload: SearchClaimDto | undefined
  ): Promise<IPagedResult<GridClaimDto>> {
    const actions: string[] = ["SearchClaims"];
    const result: IPagedResult<GridClaimDto> = await this.postAsync<
      SearchClaimDto,
      GridClaimDto,
      IPagedResult<GridClaimDto>
    >(actions, payload);
    return result;
  }

  async saveClaimAsync(
    payload: ClaimDto | undefined
  ): Promise<IActionResult<ClaimDto>> {
    const actions: string[] = ["SaveClaim"];
    return await this.postAsync<ClaimDto>(actions, payload);
  }

  async deleteClaimAsync(id?: string | undefined): Promise<IActionResponse> {
    const actions: string[] = ["DeleteClaim"];
    const params: ApiParams[] = [new ApiParams("Id", id, true)];
    return await this.deleteAsync(actions, params);
  }

  async getClaimTypesAsync(): Promise<LookupDto[]> {
    const actions: string[] = ["GetClaimTypes"];
    const result: LookupDto[] = await this.getAsync<LookupDto[]>(actions);
    return result;
  }
}
